import {IProjectSettings, ITraceDetailsGraphData} from "./Interfaces";
import {Plugin} from "./Main";
import {
    app,
    globalMatrix,
    IItem,
    ml,
    matrixSession,
    IDataStorage,
    UIToolsConstants,
    ISearchResult,
    matrixsdk,
    refLinkStyle,
    refLinkTooltip,
    XRTodo,
    IReference,
    IRestResult,
    XRTrimNeedle,
    XRTrimNeedleItem, IAnyMap, IItemSelectionParams, ControlState
} from "../../../sdk/client";
import {IDashboardPage, IDashboardParametersBase} from "../../../sdk/plugins/interfaces";
import {Project} from "../../../sdk/objects/Project";
import {ReferenceTools} from "../../../sdk/ui";
import {ITraceGraphData, ITraceRule, ITraceRuleArray} from "../TRACE/Interfaces";
import { IRestParam } from "../../../core/globals";



export interface IDashboardParameters extends IDashboardParametersBase  {
    selection: IReference[];
}
// eslint-disable-next-line no-unused-vars
export class DashboardPage implements IDashboardPage<IDashboardParameters> {
    settings: IProjectSettings;

    _root: JQuery;



    constructor(private project: Project, private projectStorage: IDataStorage,private popupModeOrControl = false, private currentFolder:string = undefined) {
        this.settings = {...Plugin.config.projectSettingsPage.defaultSettings, ...globalMatrix.ItemConfig.getSettingJSON(Plugin.config.projectSettingsPage.settingName, {})};
    }

    /** Customize static HTML here */
    private getDashboardDOM(): JQuery {
        return $(this.dashboardDOM);
    }


    /** Add interactive element in this function */
    renderProjectPage() {
        app.itemForm.append(
            ml.UI.getPageTitle(
                Plugin.config.dashboard.title,
                () => {
                    return this._root;
                },
                () => {
                    this.onResize();
                }
            )
        );
        app.itemForm.append(this.render());
        this.installCopyButtons("Traceability detailed");
    }


    render():JQuery{
        let that = this;
        that.rules = DashboardPage.getRules();
        let categories = globalMatrix.ItemConfig.getTraceConfig().rules.map(o => { return o.category });

        that._root = that.getDashboardDOM();

        $("#TRACEContentPanel",this._root).hide();

        // If a project has no traceability rules, we'll only render a simple message.
        if (!this.hasTraceability(categories, that.rules)) {
            this._root.html('<p style="padding: 5px;">No traceability rules are configured.</p>');
            return this._root;
        }
        //add item selector.
        let parameters:IItemSelectionParams = {
            prefix: "Include the following items:",
            buttonName: "Select item(s)/folder(s)",
            singleFolderOnly:false ,
            crossProject:false,
            showNot:["DOC","SIGN","REPORT",]
        }


        let itemSelectorContainer = $("#itemSelector",this._root);
        $("#TRACEContent",that._root).hide();
        if(!this.popupModeOrControl)
        {
            itemSelectorContainer.itemSelection({
                canEdit: true,
                controlState: ControlState.FormEdit,
                help: "",
                fieldValue: JSON.stringify(that.getLastSelection()),
                valueChanged: async () => {
                    $("#TRACEContentPanel",this._root).hide();
                    let v = await itemSelectorContainer.getController().getValueAsync();
                    let items = JSON.parse(v);
                    if (items != undefined) {
                        that.setLastSelection(items);
                        that.SelectionChanged(items);
                    }
                },
                parameter: parameters

            });
        }
        let baseControl = $("<div style='margin:10px;' id='itemSelectionTRACE'></div>")

        $(".toolbarButtons").append(baseControl);

        if (that.popupModeOrControl) {
            baseControl.hide();
            itemSelectorContainer.hide();

        }
        //Table filter
        $("#TRACEInputFilter").on("keyup", function (e) {
            let value = $(e.target).val().toLowerCase();
            $("#itemTraceList tbody tr").show();

            $("#itemTraceList tbody tr").each(function (index, elem) {
                if(($(elem).text().toLowerCase().indexOf(value) == -1))
                {
                    $(elem).hide();
                }
            });
        });

        if (!that.popupModeOrControl) {
            setTimeout((o:any) => that.start(), 10);
        }
        that.rules = DashboardPage.getRules();

        return  this._root;
    }



    currentCat = "";
    elementsLst: XRTodo[];

    public AllCoveredColor: string = UIToolsConstants.CIColors.GreenSushi.color;
    public MissingUp: string = UIToolsConstants.CIColors.YellowBrightSun.color;
    public MissingDown: string = UIToolsConstants.CIColors.OrangeYellow.color;
    public MissingAll: string = UIToolsConstants.CIColors.RedPersimmon.color;

    currentSelection: IReference[];

    getItems(itemList:IReference[]): JQueryDeferred<IRestResult>[] {
        let deffered: JQueryDeferred<IRestResult>[] = [];
        let that = this;
        let query =[];


        let itemsQueryParts = itemList.map((item) => {
            if (item.to && item.to[0] === 'F') {
                return " folderm =  " + item.to;
            }
            else {
                return " id = " + item.to;

            }
        });



        let mrqlQuery:string =  itemsQueryParts.join(' or ') ;

        let d = app.getNeedlesAsync(mrqlQuery);
        deffered.push(d);
        d.done((result: IItem[]) => {

            let output = that.renderTraceTable(result);
            $("#waitForIt").html("");

            setTimeout((o:any) => { that.drawChart(output)},100)


        })
        return deffered;
    }
    start() {
        let that = this;

        let cat = that.getLastSelection();

        // No automatic start in case of popup
        if (that.popupModeOrControl)
            return;
        // Get last opened Notif for that user.

        that.SelectionChanged(cat)


    }
    getLastSelection(): IReference[] {

        let value = globalMatrix.projectStorage.getItem("lastTRACEDSelection");
        if (value != undefined && value != "")
            return JSON.parse(value);
        return undefined;

    }
    setLastSelection(sel: IReference[]) {
        let selection = JSON.stringify(sel);
        this.currentSelection= sel;
        globalMatrix.projectStorage.setItem("lastTRACEDSelection", selection);
    }

    private currentFilter = "";
    filterByType(filter:any)
    {

        let that = this;
        this.currentFilter = filter.type.replace(/,/g, "-",).replace(/ /g, "_");
        if(!filter.type)
        {
            //Show all
            $("#itemTraceList tbody tr",that._root).show();
        }
        else
        {
            $("#itemTraceList tbody tr").hide();
            $("#itemTraceList tbody tr."+this.currentFilter,that._root).show();



        }


    }

    renderTraceTable(needles: IItem[]):ITraceDetailsGraphData {
        let data:ITraceDetailsGraphData = {
            allItems:[],
            hasDownMust:false,
            hasUpMust:false,
            countPerCat:{},
            missingPerCat:{}

        };



        let table = $("#itemTraceList ");
        let that = this;
        let template = $(".template", table);
        $(".addedItem", table).remove();
        $(".uplinks",that._root).hide();
        $(".downlinks",that._root).hide();

        data.hasDownMust  =false
        data.hasUpMust= false;



        if (needles != undefined) {
            needles.forEach((needle: IItem) => {

                let rule:ITraceRule = that.rules[ ml.Item.parseRef( needle.id).type ];
                let itemCat = ml.Item.parseRef(needle.id).type;


                let jqueryItem = template.clone();

                let missingDown = false;
                let missingUp = false;


                jqueryItem.attr("data-id",needle.id);

                jqueryItem = jqueryItem.removeClass("template").removeClass("hidden").addClass("addedItem");
                $(".title", jqueryItem).html("");

                let itemId = needle.id.substring(0, needle.id.lastIndexOf("-"));
                let itemLink = $(".linkTrace",jqueryItem);

                let link = $("<div></div>").refLink({
                    id: itemId, title: needle.title , style: refLinkStyle.link,  tooltip: refLinkTooltip.html, hideTitle:false
                })
                itemLink.click(() => {
                    let rt = new ReferenceTools();
                    app.getItemAsync(itemId).then((asyncItem) => {
                        //TODO :find out if i can edit or not.
                        rt.showReferenceDialog({ item: asyncItem, canEdit: true, callback:(item)=>{
                                //Refresh all
                                that.SelectionChanged(that.currentSelection);
                            }});

                    })
                });
                $(".title", jqueryItem).append(link);
                //$(".downlink",item).html("");
                data.allItems.push(needle);
                // Let's check each rule

                let downLinkCount = 0 ;
                let details:string[] = [];
                let jqueryClass = "addedItem ";
                // Let's check each rule
                rule.downMust.forEach((rules) => {
                    //Build mx-rule
                    let ruleCat = "From " + rule.cat + " down to " + rules.join("-");
                    if( data.countPerCat[ruleCat] == undefined )
                    {
                        data.countPerCat[ruleCat] = 0;
                    }
                    data.countPerCat[ruleCat] ++;

                    let count = 0;
                    data.hasDownMust = true;

                    if (needle.downLinkList != undefined) {
                        needle.downLinkList.forEach(downItem => {
                            let cat = downItem.itemRef.substring(0, downItem.itemRef.indexOf("-"));
                            if (rules.indexOf(cat) != -1)
                            {
                                count++;
                                downLinkCount++;
                            }
                        });
                    }
                    if (count == 0) {
                        missingDown = true ;
                        details.push( "missing downlink to " + rules.join(","));
                        if(data.missingPerCat[ruleCat] == undefined )
                        {
                            data.missingPerCat[ruleCat] = 0;
                        }
                        data.missingPerCat[ruleCat] ++;
                        jqueryClass += ("missing"+ruleCat).replace(/,/g, "-",).replace(/ /g, "_") + " ";

                    }else{
                        jqueryClass += ("completed"+ruleCat).replace(/,/g, "-",).replace(/ /g, "_") + " ";
                    }


                })
                $(".downlinks", jqueryItem).text(downLinkCount)

                let uplinkCount = 0

                // Let's check each rule
                rule.upMust.forEach((rules) => {
                    //Build mx-rule
                    let count = 0;
                    data.hasUpMust = true;

                    let ruleCat = "From " + rule.cat + " up to " + rules.join("-");
                    if( data.countPerCat[ruleCat] == undefined )
                    {
                        data.countPerCat[ruleCat] = 0;
                    }
                    data.countPerCat[ruleCat] ++;



                    if (needle.upLinkList != undefined) {
                        needle.upLinkList.forEach(downItem => {
                            let cat = downItem.itemRef.substring(0, downItem.itemRef.indexOf("-"));
                            if (rules.indexOf(cat) != -1)
                            {
                                count++;
                                uplinkCount++;
                            }
                        });
                    }
                    if (count == 0) {
                        missingUp = true ;
                        details.push( "missing uplink to " + rules.join(","));
                        if(data.missingPerCat[ruleCat] == undefined )
                        {
                            data.missingPerCat[ruleCat] = 0;
                        }
                        data.missingPerCat[ruleCat] ++;

                        jqueryClass += ("missing"+ruleCat).replace(/,/g, "-",).replace(/ /g, "_") + " ";

                    }else{
                        jqueryClass += ("completed"+ruleCat).replace(/,/g, "-",).replace(/ /g, "_") + " ";
                    }
                })
                $(".uplinks", jqueryItem).text(uplinkCount)
                $("tbody", table).append(jqueryItem);

                $(".linkTrace",jqueryItem).css("color",this.AllCoveredColor);

                jqueryItem.attr("class", jqueryClass);


                $(".details", jqueryItem).text(details.join(", "));
            });
        }
        if( data.hasDownMust)
        {
            $(".downlinks",that._root).show();
        }
        if( data.hasUpMust)
        {
            $(".uplinks",that._root).show();
        }


        $("#itemTraceList tbody tr").show();
        that.filterByType({type:that.currentFilter});

        for(let key in data.countPerCat)
        {
            console.log(key, data.countPerCat[key],data.missingPerCat[key] )
        }
        return data;

    }

    private hasTraceability(categories:string[], rules:ITraceRuleArray):boolean {
        let traceRules = categories.filter((o:any) => {
            return rules[o].downMust.length!=0 || rules[o].upMust.length !=0 });
        return traceRules.length > 0;
    }


    static getRules():ITraceRuleArray
    {
        let rules:ITraceRuleArray = {};
        globalMatrix.ItemConfig.getTraceConfig().rules.forEach((o: any) => {
            rules[o.category]  = {
                cat: o.category,
                upMust: o.up_rules.filter((up:any) => { return up.rule == "must_have" })
                    .map((up:any) => { return up.any_of }),
                upCan: o.up_rules.filter((up:any) => { return up.rule == "can_have" })
                    .map((up:any) => { return up.any_of }),
                downMust: o.down_rules.filter((dw:any) => { return dw.rule == "must_have" })
                    .map((down:any) => { return down.any_of }),
                downCan: o.down_rules.filter((dw:any) => { return dw.rule == "can_have" })
                    .map((down:any) => { return down.any_of })
            }
        });
        return rules;
    }

    rules: ITraceRuleArray;

    installCopyButtons(title: string) {
        let that = this;
        $("#traceTableHeader i").remove();

        ml.UI.copyBuffer($("#tracePieChartTitle"), "copy  to clipboard",this._root, this._root, (copied: JQuery) => {
            $("#itemSelector",copied).remove()
            ml.UI.fixC3ForCopy(copied);

            $("#tracePieChartTitle", copied).html("<h1>" + title + "</h1> <span> <b> Date:</b> " + ml.UI.DateTime.renderCustomerHumanDate(new Date()) +  "<br>");

        });


    }

    public SelectionChanged(itemList:IReference[]) {

        if( itemList == undefined)
            return;

        let that = this;
        $("#waitForIt").html("");
        $("#waitForIt").append(ml.UI.getSpinningWait("please wait..."));
        $(".spinningWait").show();

        that.elementsLst = [];
        $('.addedNotifRow').remove();
        if( itemList.length > 0)
        {
            this.getItems(itemList);
            $("#TRACEContentPanel").show();


        }
        $(".spinningWait").hide();

    }

    private drawChart(inputData: ITraceDetailsGraphData) {
        let that = this;
        let colums:IAnyMap= {};
        $("#TRACEContentPanel .panel-body").children().remove();
        for(let key in inputData.countPerCat)
        {

            let title = key ;
            // //key.split("-").map((k)=>{
            //    return IC.getCategoryLabel(k) + " ("+k + ") ";
            // }).join(" / ") ;

            let div = $("<div class='singleChart'> <h3>" +  title + "</h3><div class='chart'></div> </div>");
            $("#TRACEContentPanel .panel-body").append(div);
            if( inputData.missingPerCat[key] == undefined)
            {
                inputData.missingPerCat[key] = 0;
            }

            let completedPercentage = (inputData.countPerCat[key] - inputData.missingPerCat[key]) / inputData.countPerCat[key] ;
            let toCompletePercentage = inputData.missingPerCat[key] / inputData.countPerCat[key];
            colums[key] = [];
            colums[key].push(["Completed " + (completedPercentage * 100).toFixed(2) + '%', inputData.countPerCat[key] - inputData.missingPerCat[key], UIToolsConstants.CIColors.GreenSushi.color, "completed" + key]);
            colums[key].push(["To complete " + (toCompletePercentage * 100).toFixed(2) + '%', inputData.missingPerCat[key], UIToolsConstants.CIColors.RedPersimmon.color, "missing" + key])



            let chart = c3.generate({
                bindto: $(".chart", div)[0],
                data: {
                    columns: colums[key],
                    type : "donut",
                    onclick: function (d , i) {
                        that.filterByType({ type: colums[key][d.index][ colums[key][d.index].length -1] });
                    },
                    color:  function (color, d:string) {
                        let c = colums[key].filter((item)=>{return item[0] == d});
                        if( c.length>0)
                        {
                            return c[0][c[0].length -2];
                        }
                        return color;
                    }

                },
                donut: {
                    label: {
                        format: function (value, ratio, id) {
                            return (value);
                        }
                    }
                },
                legend: {
                    item: {
                        onclick: function (id) {

                            let c = colums[key].filter((item)=>{return item[0] == id});
                            if( c.length>0)
                            {
                                that.filterByType({ type: c[0][c[0].length -1] })
                            }

                        }
                    },
                    position:'inset',
                    inset:{ anchor:"top-left"}
                },
                tooltip: {
                    format: {
                        value: function (value:any, ratio:any, id:any, index:any) { return value; }
                    }
                },

            });

            $(".chart .c3-event-rects").click(function(){
                that.filterByType({type:""});
            });

        }
        return;

    }






    onResize() {
        /* Will be triggered when resizing. */
    }




    private dashboardDOM = `<div class="panel-body-v-scroll fillHeight">
        <style>
        .chartContainer
        {
            display: inline-flex;
            width: 100%;
            flex-wrap: wrap;
        }
        .singleChart {
            width:20%;
            min-witdh:200px;
            cursor:pointer;
        }
        .bigChart
        {
            min-height:700px;
        }
        </style>

        <div class="panel-body" id="toolPanel">
            <div class="row" id="waitForIt" class="spinningWait"></div>
            <div class="row" id="itemSelector" style='margin:10px;' ></div>
        </div>
         <div class="panel-body" id="TRACEContentPanel">

            <div id="">
                <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title" id="tracePieChartTitle">Charts per traceabilty rule</h3>
                </div>
                <div class="panel-body chartContainer">
                    <div class="traceTitleForCopy"></div>
                </div>
        </div></div>
        <div id="traceContent" >
        <div class="row doNotCopy">
            <div class="col-lg-3 ">
                <h3 id="TraceTableHeader">Item list</h3>
            </div>
            <div class=" col-lg-7">
            </div>
            <div class=" col-lg-2">
            <input type="text" id="TRACEInputFilter" style="margin-bottom:10px;" placeholder="filter..." class="doNotCopy  form-control"></input>
            </div>
        </div>
        <div class="traceTitleForCopy"></div>
            <table id="itemTraceList" class="table table-condensed table-borderless table-hover">
               <thead>
                <tr>
                    <th style="width:20px"> </th>
                    <th> id</th>
                    <th class="uplinks" style="width:40px"> Uplinks</th>
                    <th class="downlinks" style="width:40px"> Downlinks</th>
                    <th> Details</th>
                </tr>
               </thead>
               <tbody>
                    <tr class="template hidden">
                        <td style="display:flex"><i class="fal fa-sitemap linkTrace"></i></td>
                        <td class="title" >MyITEM : my title ablash </td>
                        <td class="uplinks"> xx</td>
                        <td class="downlinks"> xx</td>
                        <td class=""> <small class="details">Missing TC and SPEC</small></td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
        </div>
        `
}
